/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { TemplatesList, AlertTemplateDTO, TemplatesListSearchParams } from '../api/alerts/alertsClient.typings';

export enum AlertsSettingsActionType {
    OPEN_ALERTS_SETTINGS_PAGE = 'Alerts settings/ open page',
    EXIT_ALERTS_SETTINGS_PAGE = 'Alerts settings/ exit page',

    FETCH_ALERTS_TEMPLATES_SUCCESS = 'Alerts settings/ fetch alerts templates success',
    UPDATE_ALERT_TEMPLATE = 'Alerts settings/ update alert template',
    UPDATE_ALERT_TEMPLATE_SUCCESS = 'Alerts settings/ update alert template success',

    CHANGE_ALERTS_TEMPLATES_SEARCH_PARAMS = 'Alerts settings/ change search params',

    SET_LOADING = 'Alerts settings/ set loading',

    ALERTS_SETTINGS_PAGE_ERROR = 'Alerts settings/ alerts settings screen error',
}

export const openAlertsSettingsPageAction = () => createAction(AlertsSettingsActionType.OPEN_ALERTS_SETTINGS_PAGE);

export const exitAlertsSettingsPageAction = () => createAction(AlertsSettingsActionType.EXIT_ALERTS_SETTINGS_PAGE);

export const fetchAlertsTemplatesSuccessAction = (templatesList: TemplatesList) =>
    createAction(AlertsSettingsActionType.FETCH_ALERTS_TEMPLATES_SUCCESS, templatesList);

export const changeAlertsTemplatesSearchParamsAction = (params: TemplatesListSearchParams) =>
    createAction(AlertsSettingsActionType.CHANGE_ALERTS_TEMPLATES_SEARCH_PARAMS, params);

export const alertsSettingsNotificationAction = (notification: Notification) =>
    createAction(AlertsSettingsActionType.ALERTS_SETTINGS_PAGE_ERROR, { notification });

export const updateAlertTemplateAction = (template: AlertTemplateDTO) =>
    createAction(AlertsSettingsActionType.UPDATE_ALERT_TEMPLATE, template);

export const updateAlertTemplateSuccess = (template: AlertTemplateDTO) =>
    createAction(AlertsSettingsActionType.UPDATE_ALERT_TEMPLATE_SUCCESS, template);

export const setLoadingAction = () => createAction(AlertsSettingsActionType.SET_LOADING);

export type AlertsSettingsAction =
    | ReturnType<typeof openAlertsSettingsPageAction>
    | ReturnType<typeof exitAlertsSettingsPageAction>
    | ReturnType<typeof alertsSettingsNotificationAction>
    | ReturnType<typeof fetchAlertsTemplatesSuccessAction>
    | ReturnType<typeof updateAlertTemplateAction>
    | ReturnType<typeof updateAlertTemplateSuccess>
    | ReturnType<typeof setLoadingAction>
    | ReturnType<typeof changeAlertsTemplatesSearchParamsAction>;
